<div id="wachterNotesControl">
  <div class="SearchParts" dwRow>
    <div dwCol="4">
      <i class="fas fa-search icon"></i>
      <input class="search-box" (input)="onSearch(search.value)" #search type="text">
    </div>
    <div dwCol="8">
      <label [hidden]="noteControlConfig.HideAutoDelete" class="compact-config-checkbox auto-delete">Auto-Delete
        <input type="checkbox" [(ngModel)]="autoDelete">
      </label>
    </div>
  </div>

  <div class="form-group preserve-newlines" style='overflow-y:auto;max-height: 400px;' suppressHorizontalScroll>
    <div *ngFor="let item of comments| search:'Comment':searchQuery;trackBy: trackNote">
      <div class="note-contents" *ngIf="!editing || editing.id === item.id">
        <span class="note-header">
          {{item.CreatedBy}} @ {{moment(moment.utc(item.CreatedOn)).local().format("MM/DD/YYYY, hh:mm a")}}
          <i *ngIf="hasEditPermission && !editing" 
              class="edit-btn" (click)="onEditNote(item, content); "></i>
          <i *ngIf="hasEditPermission && editing && editing.id === item.id" 
              class="undo-btn" (click)="onUndoNoteEdit(item, content); "></i>
          <i *ngIf="hasEditPermission && editing && editing.id === item.id && isNoteDirty" 
              class="save-btn" (click)="onSaveNoteChanges(item, content); "></i>
          <i *ngIf="hasDeletePermission && !editing" 
              class="delete-btn" (click)="onDeleteNote(item.id, content); "></i>
          <span *ngIf="item.ModifiedOn" class="modified-by">
            Modified: <span *ngIf="item.ModifiedBy && item.ModifiedBy !== item.CreatedBy">{{item.ModifiedBy}}</span> @ {{moment(moment.utc(item.ModifiedOn)).local().format("MM/DD/YYYY, hh:mm a")}}
          </span>
        </span>
        <span class="note-text">
          <dw-html-view *ngIf="!editing || editing.id !== item.id" [ngModel]="item.Comment"></dw-html-view> 
          <wachter-note-editor *ngIf="editing && editing.id === item.id" [note]="item.Comment"
                               (noteChange)="onCommentChange($event)"></wachter-note-editor>
        </span>
        <span *ngIf="item.ShowSource" class="note-source">
          <b>Source:</b>&nbsp;
          <a (click)="item.navToSource(item)">
            <dw-lookup-readonly *ngIf="item.ShowSource" [lookupId]="item.MetaDataLookupId" [(ngModel)]="item.RecordId">
            </dw-lookup-readonly>
          </a>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="!editing" [hidden]="isReadOnly == true">
    <label for="comment">Add Comment:</label>
    <wachter-note-editor [note]="newComment" (noteChange)="onNewCommentUpdate($event)"></wachter-note-editor>
  </div>

  <button [hidden]="isReadOnly == true" (click)="onAddNoteClicked()" type="button" class="btn btn-success" *ngIf="!editing"
    [disabled]="!newComment || isSaving">Save Note</button>
  <dw-loading [show]="isSaving" text="Saving Note"></dw-loading>
  <div [hidden]="isReadOnly == true" *ngIf="!editing" style="color: red;">* Any notes that have not been saved will not save unless you click 'Save Note'</div>
</div>
